import * as tracking from 'dibs-tracking';

function trackCollectionsImpression({ items, startIndex }) {
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: items.map((item, index) => ({
            id: 'small-item-carousel',
            name: 'Small Item Carousel',
            creative: item.title,
            position: startIndex + index + 1,
        })),
    });
}

function trackCollectionsItemClick({ item, index }) {
    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [
            {
                id: 'small-item-carousel',
                name: 'Small Item Carousel',
                creative: `Small Item Carousel : ${item.title}`,
                position: index + 1,
            },
        ],
    });
}

function trackArrowClick({ type }) {
    tracking.trackEvent({
        action: 'small item carousel',
        category: 'promo interaction',
        label: `${type} arrow clicked`,
    });
}

export { trackCollectionsImpression, trackCollectionsItemClick, trackArrowClick };
